import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'

export const inverted = (theme: Theme) => css`
  color: ${theme.palette.background.main};
`
